import { useEffect, useState } from 'react';
import Box from 'elements/Box';
import { Button, IconButton, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AlertDialog from 'elements/AlertDialog';
import AddIcon from '@mui/icons-material/Add';
import { useSnackbar } from 'notistack';

import 'assets/css/main.css';

import BannersEditor from './BannersEditor';
import { ApiRequest } from 'GlobalFunctions';

export default function BannersList(props: any) {
  const { enqueueSnackbar } = useSnackbar();
  const { setLoading } = props;

  useEffect(() => {
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const [list, setList] = useState<any[]>([]);
  const currentPage = parseInt(localStorage.getItem('bannerPage') || "1");
  const [page] = useState(currentPage);
  const [openEditor, setOpenEditor] = useState(false);
  const [activeItem, setActiveItem] = useState<any>(null);
  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => {
    setLoading(true);
    loadList();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const loadList = async () => {
    setLoading(true);

    await ApiRequest({
      url: "/banners/list",
      method: "GET",
      query: {
        page: page,
      },
      setResponse: (response: any) => {
        setList(response.list);
        setLoading(false);
      },
    });

    localStorage.setItem('bannerPage', page.toString());
  };

  const handleDelete = (banner_id: number) => {
    setActiveItem(banner_id);
    setOpenAlert(true);
  };

  const toggleActive = (banner_id: number, currentActive: number) => {
    const newActive = currentActive === 1 ? 0 : 1;
    ApiRequest({
      url: '/banners/toggleActive',
      method: 'POST',
      body: { banner_id, active: newActive },
      setResponse: (response: any) => {
        if (response.status === 'success') {
          enqueueSnackbar(response.message, { variant: 'success' });
          loadList();
        }
      },
      onError: (msg: string) => enqueueSnackbar(msg, { variant: 'error' }),
    });
  };

  const deleteItem = () => {
    ApiRequest({
      url: "/banners/deleteItem",
      method: "POST",
      body: { banner_id: activeItem },
      setResponse: (response: any) => {
        setOpenAlert(false);
        if (response.status === "success") {
          enqueueSnackbar('Banner eliminado con éxito', { variant: 'success' });
          loadList();
        } else {
          enqueueSnackbar(response.message || 'Error al eliminar banner', { variant: 'error' });
        }
      },
      onError: (msg: string) => {
        setOpenAlert(false);
        enqueueSnackbar(msg, { variant: 'error' });
      },
    });
  };

  return (
    <div id='BrandList' className='content'>
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Marcas</h2>
            <span className="h2_subtitle">Lista de banners</span>
          </div>
          <div className="boxContainerActions">
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setActiveItem(null);
                setOpenEditor(true);
              }}
              startIcon={<AddIcon />}
            >
              Crear banner
            </Button>
          </div>
        </div>

        <Box id='BrandListIn' className='box100'>
          <TableContainer>
            <Table aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Banner</TableCell>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Tipo</TableCell>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Ubicación</TableCell>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Estado</TableCell>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}>Clicks</TableCell>
                  <TableCell sx={{ color: '#a8a8a8', borderBottom: "none" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item, i) => (
                  <TableRow key={i} hover role="checkbox">

                    <TableCell width={100}>
                      <img src={item.image} alt={item.section} style={{ width: '100px', height:'50px', objectFit:"contain" }} />
                    </TableCell>
                    <TableCell>
                      {item.section.startsWith('slider-') ? (
                        <span style={{
                          background: '#dbeafe', color: '#1d4ed8',
                          padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600,
                        }}>Slider</span>
                      ) : (
                        <span style={{
                          background: '#f0fdf4', color: '#16a34a',
                          padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600,
                        }}>Popup</span>
                      )}
                    </TableCell>
                    <TableCell>
                      {item.section.replace('slider-', '').replace('global', 'Todas las páginas').toUpperCase()}
                    </TableCell>

                    <TableCell>
                      <Tooltip title={item.active ? 'Activo — clic para desactivar' : 'Inactivo — clic para activar'}>
                        <Switch
                          checked={item.active === 1}
                          onChange={() => toggleActive(item.banner_id, item.active)}
                          color="primary"
                          size="small"
                        />
                      </Tooltip>
                      <span style={{ fontSize: 12, color: item.active ? '#16a34a' : '#94a3b8', marginLeft: 4 }}>
                        {item.active ? 'Activo' : 'Inactivo'}
                      </span>
                    </TableCell>

                    <TableCell align="center">
                      <span style={{
                        fontWeight: 700,
                        fontSize: 16,
                        color: item.click_count > 0 ? '#135095' : '#94a3b8',
                      }}>
                        {item.click_count ?? 0}
                      </span>
                    </TableCell>

                    <TableCell align="right">
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        style={{ marginRight: "10px" }}
                        onClick={() => {
                          setActiveItem(item.banner_id);
                          setOpenAlert(true);
                        }}
                      >
                        Borrar
                      </Button>

                      {(localStorage.getItem('role_id') === "1" || localStorage.getItem('role_id') === "2") &&
                      <IconButton aria-label="delete" color="primary" onClick={() => handleDelete(item.banner_id)}>
                        <DeleteOutlineOutlinedIcon />
                      </IconButton>
                      }
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          
        </Box>
      </div>

      <AlertDialog
        open={openAlert}
        setOpen={setOpenAlert}
        subtitle="¿Está seguro que desea eliminar esta banner?"
        send={deleteItem}
      />

      <BannersEditor
        setLoading={setLoading}
        openEditor={openEditor}
        setOpenEditor={setOpenEditor}
        banner_id={activeItem}
        loadList={loadList}
      />
    </div>
  );
};
